import { Box, Card, CardContent, Typography } from "@mui/material";
import React, { useState } from "react";

const PyramidGraph = ({
  title,
  data,
  baseWidth = 20,
  baseHeight = 35,
  baseMargin = 5,
  fontSize = 12,
  colors = [],
  cardHeight = 180,
}) => {
  const [hoverIndex, setHoverIndex] = useState(null);
  return (
    <Card>
      <Typography
        sx={{
          fontSize: 17,
          textAlign: "center",
          margin: "0 8px",
          marginTop: 1,
        }}
      >
        {title}
      </Typography>
      <CardContent>
        <Box
          sx={{
            height: cardHeight,
            display: "flex",
            flexDirection: "column",
            // alignItems: "center",
            justifyContent: "center",
          }}
        >
          {data?.map((dt, idx) => (
            <div
              key={idx}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  fontSize,
                  width: "40%",
                  display: "inline",
                  textAlign: "right",
                }}
              >
                {dt.groupName}
              </div>
              <div
                style={{ width: "55%", marginLeft: "5%", position: "relative" }}
              >
                {hoverIndex === idx ? (
                  <div
                    style={{
                      position: "absolute",
                      bottom: baseHeight + 5,
                      backgroundColor: "#000",
                      opacity: "80%",
                      padding: 5,
                      borderRadius: 5,
                      zIndex: 999,
                      fontSize: 13,
                      fontWeight: "bold",
                    }}
                  >
                    <span style={{ opacity: "100%", color: "#fff" }}>
                      {dt.groupName}: {dt.countData}
                    </span>
                  </div>
                ) : null}
                <div
                  onMouseEnter={() => setHoverIndex(idx)}
                  onMouseLeave={() => setHoverIndex(null)}
                  style={{
                    width: `${
                      idx * baseWidth +
                      baseWidth +
                      (idx === 0 ? 0 : idx * baseMargin)
                    }px`,
                    height: "0",
                    borderBottom: `${baseHeight}px solid ${
                      colors?.[idx] ? colors[idx] : "#ff3e4d"
                    }`,
                    borderRight: `${baseWidth}px solid transparent`,
                    marginBottom: `${
                      idx === data.length - 1 ? 0 : baseMargin
                    }px`,
                    opacity: hoverIndex === idx ? "100%" : "80%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span
                    style={{
                      marginTop: baseHeight + 5,
                      marginLeft: baseWidth / 2,
                      fontSize: 13,
                    }}
                  >
                    {dt.countData}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default PyramidGraph;
